/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>('/api/currentUser', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/login/outLogin', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(
  body: API.LoginParams,
  options?: { [key: string]: any },
) {
  return request<API.LoginResult>('/api/login/account', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 取号接口 POST /api/order/take  */
export async function takeNumber(
  body: API.TakeNumberParams,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.TakeNumberResult>>('/api/order/take', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 取号列表 POST /api/order/take/list  */
export async function takeList(
  body: API.TakeListParams,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.TableResult<API.TakeNumberResult>>>(
    '/api/order/take/list',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 取消取号 POST /api/order/take/cancel  */
export async function takeCancel(
  body: API.TakeCancelParams,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<void>>('/api/order/take/cancel', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 过号 POST /api/order/take/delay  */
export async function takeDelay(
  body: API.TakeDelayParams,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<void>>('/api/order/take/delay', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 到号 POST /api/order/take/sign  */
export async function takeSign(
  body: API.TakeSignParams,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.TakeNumberResult>>(
    '/api/order/take/sign',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 重新打印小票 POST /api/order/take/ticket  */
export async function ticket(
  body: API.TakeSignParams,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<void>>('/api/order/take/ticket', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 分页查询类目 POST /api/item/categories  */
export async function API_queryCategories(
  body: API.CategoryQueryReqeust,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.TableResult<API.CategoryView>>>(
    '/api/item/categories',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 类目状态修改 POST /api/item/category/state  */
export async function API_changeCategoryState(
  body: API.StateRequest,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<void>>('/api/item/category/state', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 类目删除 POST /api/item/category/delete  */
export async function API_deleteCategory(
  body: API.CodeRequest,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<void>>('/api/item/category/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 类目新增 POST /api/item/category/create  */
export async function API_createCategory(
  body: API.CreateCategoryRequest,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<string>>('/api/item/category/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 类目更新 POST /api/item/category/update  */
export async function API_updateCategory(
  body: API.CreateCategoryRequest,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<string>>('/api/item/category/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 类目顺序移动 POST /api/item/category/move  */
export async function API_moveCategory(
  body: API.MoveRequest,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<string>>('/api/item/category/move', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 类目下拉选项 POST /api/item/category/option  */
export async function API_categoryOption(
  body: { state?: 'ENABLED' | 'DISABLED' | undefined },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<OptionView[]>>('/api/item/category/option', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 分页查询品 POST /api/item/query  */
export async function API_queryItems(
  body: API.ItemQueryReqeust,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.TableResult<API.ItemView>>>(
    '/api/item/query',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 品新增 POST /api/item/create  */
export async function API_createItem(
  body: API.CreateItemRequest,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<string>>('/api/item/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 品修改 POST /api/item/update  */
export async function API_updateItem(
  body: API.CreateItemRequest,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<string>>('/api/item/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 品状态修改 POST /api/item/state  */
export async function API_changeState(
  body: API.StateRequest,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<void>>('/api/item/state', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 品删除 POST /api/item/delete  */
export async function API_deleteItem(
  body: API.CodeRequest,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<void>>('/api/item/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 分页查询品关联 POST /api/item/relation/query  */
export async function API_queryItemRelation(
  body: API.CategoryQueryReqeust,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.TableResult<API.ItemRelationView>>>(
    '/api/item/relation/query',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 品关联顺序移动 POST /api/item/relation/move  */
export async function API_moveRelation(
  body: API.MoveRequest & { categoryCode: string },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<string>>('/api/item/relation/move', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 分页查询品 POST /api/discount/query  */
export async function API_queryDiscounts(
  body: API.DiscountQueryReqeust,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.TableResult<API.DiscountView>>>(
    '/api/discount/query',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 品新增 POST /api/discount/create  */
export async function API_createDiscount(
  body: API.CreateDiscountRequest,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<string>>('/api/discount/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 优惠修改 POST /api/discount/update  */
export async function API_updateDiscount(
  body: API.CreateDiscountRequest,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<string>>('/api/discount/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 优惠状态修改 POST /api/discount/state  */
export async function API_changeDiscountState(
  body: API.StateRequest,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<void>>('/api/discount/state', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 优惠删除 POST /api/discount/delete  */
export async function API_deleteDiscount(
  body: API.CodeRequest,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<void>>('/api/discount/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 折扣下拉选择 查询 POST /api/discount/option */
export async function API_discountOptions(params?: { type?: string }) {
  return request<API.ApiResponse<API.OptionView[]>>('/api/discount/option', {
    method: 'POST',
    data: params || {},
  });
}

/** 店铺信息 查询 GET /api/tenant/get  */
export async function API_getTenant(options?: { [key: string]: any }) {
  return request<API.ApiResponse<API.TenantView>>('/api/tenant/get', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    ...(options || {}),
  });
}

/** 店铺信息 查询 POST /api/tenant/update  */
export async function API_updateTenant(
  body: API.ConfigTenantRequest,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<void>>('/api/tenant/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 分类品信息查询 查询 GET /api/item/cateItems  */
export async function API_cateItems(options?: { [key: string]: any }) {
  return request<API.ApiResponse<API.CateItemView[]>>('/api/item/cateItems', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    ...(options || {}),
  });
}

/** 查询指标 查询 POST /api/statics/fetch  */
export async function API_fetchStatics(
  body: API.FetchStaticsRequest,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.FetchStaticsResponse>>(
    '/api/statics/fetch',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询订阅操作记录 POST /api/subscription/logs */
export async function API_querySubscriptionLogs(
  body: API.Page,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.TableResult<API.SubscriptionLogView>>>(
    '/api/subscription/logs',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询订阅操作记录历史 POST /api/subscription/logs */
export async function API_querySubscriptionLogsHistory(
  body: API.Page,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.TableResult<API.SubscriptionLogView>>>(
    '/api/subscription/logs',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 获取当前租户今日第一笔订阅消息并标记为已读 POST /api/subscription/logs/readed */
export async function API_getTodayFirstSubscriptionLog(options?: {
  [key: string]: any;
}) {
  return request<API.ApiResponse<API.SubscriptionLogView>>(
    '/api/subscription/logs/readed',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      ...(options || {}),
    },
  );
}

/** 更新订阅操作记录的已读状态 POST /api/subscription/logs/readed/update */
export async function API_updateSubscriptionLogReadStatus(
  body: { id?: number; bizCode?: string; readed?: boolean },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<string>>(
    '/api/subscription/logs/readed/update',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 获取仪表盘汇总数据 GET /api/v1/dashboard/summary */
export async function API_getDashboardSummary(params: API.DashboardParams) {
  return request<API.ApiResponse<API.DashboardSummary>>(
    '/api/v1/dashboard/summary',
    {
      method: 'GET',
      params,
    },
  );
}

/** 获取报表趋势数据 GET /api/v1/dashboard/trends */
export async function API_getDashboardTrends(params: API.DashboardParams) {
  return request<API.ApiResponse<API.DashboardTrends>>(
    '/api/v1/dashboard/trends',
    {
      method: 'GET',
      params,
    },
  );
}

/** 获取菜品排行榜 GET /api/v1/dashboard/dish-rankings */
export async function API_getDishRankings(params: API.DashboardParams) {
  return request<API.ApiResponse<API.DishRankings>>(
    '/api/v1/dashboard/dish-rankings',
    {
      method: 'GET',
      params,
    },
  );
}

/** 获取全量启用中的菜品 GET /api/item/enabled-items */
export async function API_getEnabledItems() {
  return request<API.ApiResponse<API.ItemView[]>>('/api/item/enabled-items', {
    method: 'GET',
  });
}

/** 获取特定菜品销量趋势 GET /api/v1/dashboard/dish-sales-trend */
export async function API_getDishSalesTrend(params: API.DishSalesTrendParams) {
  return request<API.ApiResponse<API.DishSalesTrendPoint[]>>(
    '/api/v1/dashboard/dish-sales-trend',
    {
      method: 'GET',
      params,
    },
  );
}
